// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  RangeDatePickerInput,
  DatePickerInput,
  TextInput,
} from '@wajeez-web/components/ui';
import { Server } from '@wajeez/wajeez.microservices';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useDebounce } from '@wajeez-web/components/helpers';

import { FilterOption } from './TableFilter';
import { Select } from '../..';

export const useFilterInput = (
  appliedFilters: FilterOption[],
  setAppliedFilters: React.Dispatch<React.SetStateAction<FilterOption[]>>,
  onChange?: (filters: FilterOption[]) => void
) => {
  const applyFilter = (value: string | undefined, filter: FilterOption) => {
    const foundFilter = appliedFilters.find((a) => a.key === filter.key);

    const newFilters = appliedFilters.map((a) => {
      if (a.key === filter.key) {
        return { ...filter, value };
      } else {
        return a;
      }
    });

    if (value) {
      setAppliedFilters(
        foundFilter ? newFilters : [...appliedFilters, { ...filter, value }]
      );
    } else {
      setAppliedFilters(appliedFilters.filter((af) => af.key !== filter.key));
    }

    if (filter.onChange) {
      filter.onChange(value);
    }
  };

  const applyFilterRequest = (
    value: string | undefined,
    filter: FilterOption
  ) => {
    const foundFilter = appliedFilters.find((a) => a.key === filter.key);

    const newFilters = appliedFilters.map((a) => {
      if (a.key === filter.key) {
        return { ...filter, value };
      } else {
        return a;
      }
    });

    if (onChange) {
      if (value) {
        onChange(
          foundFilter ? newFilters : [...appliedFilters, { ...filter, value }]
        );
      } else {
        onChange(appliedFilters.filter((af) => af.key !== filter.key));
      }
    }
  };

  const [setTextInputDataDebounced] = useDebounce((data) => {
    const value = data?.value;
    const filter = data?.['filter'];

    applyFilterRequest(value, filter);
  });

  const renderFilterInput = (filter: FilterOption) => {
    if (
      filter.dataType === Server.DataType.Date ||
      filter.dataType === Server.DataType.DateTime
    ) {
      if (Number(filter.operator) === Server.ComparisonType.Between) {
        return (
          <div className="w-full flex justify-center items-center">
            <div className="w-full">
              <RangeDatePickerInput
                name={`table-date-filter-${filter.key}`}
                onChange={(name, value) => {
                  applyFilter(value, filter);

                  applyFilterRequest(value, filter);
                }}
                value={
                  appliedFilters.find((af) => af.key === filter.key)?.value ||
                  null
                }
                showTime={filter.dataType === Server.DataType.DateTime}
              />
            </div>
          </div>
        );
      } else if (filter.operator !== undefined) {
        return (
          <div className="w-full flex justify-center items-center">
            <div className="w-full">
              <DatePickerInput
                name={`table-date-filter-${filter.key}`}
                onChange={(name, value) => {
                  applyFilter(value, filter);

                  applyFilterRequest(value, filter);
                }}
                value={
                  appliedFilters.find((af) => af.key === filter.key)?.value ||
                  null
                }
                placeholder=""
                showTime={filter.dataType === Server.DataType.DateTime}
              />
            </div>
          </div>
        );
      }
    } else if (
      filter.dataType === Server.DataType.String ||
      filter.dataType === Server.DataType.Number ||
      filter.dataType === Server.DataType.NumberCurrency ||
      filter.dataType === Server.DataType.Trimmable
    ) {
      if (!filter.options) {
        return (
          <div className="w-full flex justify-center items-center">
            <div className="w-full">
              <TextInput
                name={`table-string-filter-${filter.key}`}
                onChange={(name, value) => {
                  applyFilter(value, filter);

                  setTextInputDataDebounced({ value, filter });
                }}
                value={
                  appliedFilters.find((af) => af.key === filter.key)?.value ||
                  ''
                }
              />
            </div>
          </div>
        );
      } else {
        const foundFilter = appliedFilters.find((af) => af.key === filter.key);

        return (
          <div className="w-full h-[30px]">
            <Select
              name={`table-boolean-filter-${filter.key}`}
              options={filter.options.map((o) => {
                return {
                  value: o,
                  label: o,
                };
              })}
              onChange={(option) => {
                applyFilter(option.value, filter);

                applyFilterRequest(option.value, filter);
              }}
              option={
                foundFilter
                  ? {
                      value: foundFilter?.value,
                      label: foundFilter?.value,
                    }
                  : undefined
              }
              autoWidth={false}
              isLocalized={false}
            />
          </div>
        );
      }
    } else if (filter.dataType === Server.DataType.Boolean) {
      const foundFilter = appliedFilters.find((af) => af.key === filter.key);

      return (
        <div className="w-full h-[30px]">
          <Select
            name={`table-boolean-filter-${filter.key}`}
            options={[
              { value: 'True', label: 'True' },
              { value: 'False', label: 'False' },
            ]}
            onChange={(option) => {
              applyFilter(option.value, filter);

              applyFilterRequest(option.value, filter);
            }}
            option={
              foundFilter
                ? {
                    value: foundFilter?.value,
                    label: foundFilter?.value,
                  }
                : undefined
            }
            autoWidth={false}
          />
        </div>
      );
    }

    return null;
  };

  return { renderFilterInput, applyFilter, applyFilterRequest };
};
